import { makeGetRequest } from 'owa-ows-gateway';
import type { ActivityFeedSettingsResponse } from '../service/ActivityFeedSettingType';

const GET_ACTIVITY_FEED_SETTINGS_URL: string =
    '/ows/beta/OutlookCloudSettings/settings/account?settingname=notification_settings';

export const getActivityFeedSettings: () => Promise<ActivityFeedSettingsResponse> = () =>
    makeGetRequest(GET_ACTIVITY_FEED_SETTINGS_URL);
